export enum FlourTransferStatusTypes {
  Generated = 'Generiert',
  OutgoingDeliveryPartiallyCreated = 'Ausgehende Lieferung teilweise erstellt',
  OutgoingDeliveryCreated = 'Ausgehende Lieferung erstellt',
  IncomingDeliveryPartiallyCreated = 'Eingehende Lieferung teilweise erstellt',
  Completed = 'Abgeschlossen',
  CompletedWithWarning = 'Abgeschlossen mit Warnung'
}
